/* SOLWE: header search auto-focus - CUSTOMIZATIONS.md #1 */
document.addEventListener('DOMContentLoaded', function () {
  function tryFocus(el, attemptsLeft) {
    if (!el || attemptsLeft <= 0) return;
    el.focus();
    if (document.activeElement !== el) {
      requestAnimationFrame(function () {
        tryFocus(el, attemptsLeft - 1);
      });
    }
  }

  /* Desktop header (header-navigation-hamburger.liquid): search opens via its own <details>. */
  var desktopInput = document.getElementById('Search-In-Modal-Menu-Hamburger');
  var desktopDetails = desktopInput && desktopInput.closest('details');

  if (desktopDetails) {
    desktopDetails.addEventListener('toggle', function () {
      if (desktopDetails.open) tryFocus(desktopInput, 30);
    });
  }

  /* Mobile header (header-mobile.liquid): search opens the off-canvas sidebar via a body class,
     not via its own <details> - that stays permanently open from theme.js on mobile viewports,
     which also forces the desktop <details> above open at the same time. Retrying for up to
     ~0.5s (rather than focusing once) rides out the sidebar's own reveal transition, and gives
     up harmlessly if the input never becomes focusable - e.g. because the desktop <details>
     toggled on a viewport where the mobile sidebar itself is hidden, or vice versa. */
  var mobileInput = document.getElementById('Search-In-Modal-Sidebar');

  if (mobileInput) {
    var wasMobileSearchOpen = document.body.classList.contains('open_search_mobile');

    new MutationObserver(function () {
      var isMobileSearchOpen = document.body.classList.contains('open_search_mobile');

      if (isMobileSearchOpen && !wasMobileSearchOpen) tryFocus(mobileInput, 30);

      wasMobileSearchOpen = isMobileSearchOpen;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
});
/* /SOLWE */
